import { z } from 'zod';
import { AI_MODULES, AI_PROVIDERS, AI_PROMPT_SLUGS } from '../constants.js';
import { uuidSchema } from './primitives.js';

export const aiModuleLimitSchema = z.object({
  enabled: z.boolean(),
  provider: z.enum(AI_PROVIDERS),
  model: z.string().min(1),
  monthly_tokens: z.number().int().min(0),
  monthly_requests: z.number().int().min(0).optional(),
  max_input_tokens: z.number().int().min(1).optional(),
  top_k_results: z.number().int().min(1).max(50).optional(),
  similarity_threshold: z.number().min(0).max(1).optional(),
  max_context_chunks: z.number().int().min(1).max(50).optional(),
  max_chunk_tokens: z.number().int().min(64).max(8192).optional(),
});
export type AIModuleLimit = z.infer<typeof aiModuleLimitSchema>;

export const planAILimitsSchema = z.object({
  enabled: z.boolean().default(true),
  shared_across_seats: z.boolean().default(true),
  block_on_quota_exceeded: z.boolean().default(true),
  modules: z.object({
    suggest: aiModuleLimitSchema,
    summary: aiModuleLimitSchema,
    autolink: aiModuleLimitSchema,
    rag_chat: aiModuleLimitSchema,
    embedding: aiModuleLimitSchema,
    voice_agent: aiModuleLimitSchema.optional(),
  }),
});
export type PlanAILimits = z.infer<typeof planAILimitsSchema>;

export const aiSuggestInput = z.object({
  documentId: uuidSchema,
  context: z.string().max(8000).optional(),
});
export const aiSummarizeInput = z.object({
  documentId: uuidSchema,
  mode: z.enum(['short', 'long', 'bullets']).default('short'),
});
export const aiRewriteInput = z.object({
  documentId: uuidSchema,
  style: z.string().min(1).max(64),
});
export const aiRagQueryInput = z.object({
  workspaceId: uuidSchema,
  query: z.string().min(1).max(2000),
  sessionId: uuidSchema.optional(),
});

export const aiPromptInput = z.object({
  slug: z.enum(AI_PROMPT_SLUGS),
  body: z.string().min(1).max(20_000),
  variables: z.record(z.any()).optional(),
});

export const aiModuleEnum = z.enum(AI_MODULES);
